import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=3476fc32&"
import script from "./addPrice.vue?vue&type=script&lang=js&"
export * from "./addPrice.vue?vue&type=script&lang=js&"
import style0 from "./addPrice.vue?vue&type=style&index=0&id=3476fc32&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports